import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { setSizeContent } from '../messages/pdpDetailsMessages';

function PdpSharedDetailSetSize(props) {
    const { item } = props;
    if (!(item.setSize > 1)) {
        return null;
    }
    return <span data-tn="pdp-spec-set-size">{setSizeContent(item.setSize)}</span>;
}

PdpSharedDetailSetSize.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailSetSize, {
    item: graphql`
        fragment PdpSharedDetailSetSize_item on Item {
            setSize
        }
    `,
});
